<template>
  <div class="search-scan">
    <div class="search">
      <!-- <div class="search-icon">
        <img src="@/assets/img/icon-search-gray.png" />
      </div>
      <input type="search" :placeholder="placeholder" v-model="value" /> -->
      <form action="/">
        <van-search
          v-model="value"
          :placeholder="placeholder"
          :left-icon="imgSrc"
          clearable
          @search="onSearch"
        />
      </form>
      <div v-if="showscan" class="scan" @click="scan">
        <img src="@/assets/img/icon_scan_white.png" />
      </div>
    </div>
  </div>
</template>

<script>
import { platformAgent } from '@/utils/utils'
export default {
  props: {
    valuePar: {
      default: '',
      type: String
    },
    placeholder: {
      default: '',
      type: String
    },
    showscan: {
      default: true,
      type: Boolean
    }
  },
  data() {
    return {
      value: '',
      timer: null,
      imgSrc: require('@/assets/img/icon-search-gray.png')
    }
  },
  watch: {
    value(val) {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        this.$emit('getValue', val)
      }, 500)
    },
    valuePar(newVal) {
      this.value = this.valuePar
    }
  },
  created() {
    this.value = this.valuePar
  },
  methods: {
    scan() {
      if (platformAgent() == 'android') {
        window.SyHybridSdk.scan({
          success: res => {
            let code = res.resultData
            if (typeof code != 'string') {
              code = code.toString()
            }
            this.value = code.toString()
          }
        })
      } else if (platformAgent() == 'ios') {
        window.SyHybridSdk.openOriActivity({
          params: {
            hostName: 'ScanCodeViewController'
          },
          success: res => {
            if (typeof res != 'string') {
              res = res.toString()
            }
            this.value = res.toString()
          }
        })
      }
    },
    onSearch() {
      this.$emit('getValue', this.value)
    }
  }
}
</script>

<style scoped lang="less">
.search-scan {
  // background: #ecc381;
  width: 100%;
  // padding: 8px 15px;
  box-sizing: border-box;
  border: 1px solid #ecc381;
  border-radius: 18px;
  .search {
    height: 35px;
    border-radius: 18px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 3px;
    // box-sizing: border-box;
    :deep(.van-field__left-icon) {
      display: flex;
      align-items: center;
    }
    .search-icon {
      padding-left: 6px;
      width: 14px;
      height: 14px;
      img {
        width: 14px;
        height: 14px;
      }
    }
    input {
      border: none;
      flex-grow: 1;
      font-size: 15px;
    }
    input::placeholder {
      color: #b3b3b3;
    }
    .scan {
      width: 60px;
      height: 29px;
      border-radius: 15px;
      background: #ecc381;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 17px;
        height: 17px;
        display: block;
      }
    }
    form {
      flex-grow: 1;
    }
    .van-search {
      padding: 0;
      background: none;
      width: 100%;
    }
    .van-search__content {
      background: none;
    }
  }
}
</style>
